/* tslint:disable */
import {
  Sector,
  Report,
  County,
  SubCounty,
  SectorType,
  SectorCategory,
  Constituency,
  ServiceCharterGrouping
} from '../index';

declare var Object: any;
export interface InstitutionsInterface {
  "name": string;
  "ownership"?: string;
  "gender"?: string;
  "latitude": number;
  "longitude": number;
  "street_address": string;
  "postal_address": string;
  "website"?: string;
  "service_charter_url"?: string;
  "contact_name": string;
  "contact_phone": string;
  "contact_email"?: string;
  "active": boolean;
  "visible": boolean;
  "model"?: string;
  "property"?: string;
  "accessType"?: string;
  "permission"?: string;
  "principalType"?: string;
  "principalId"?: string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  "sector_id"?: number;
  "county_id"?: number;
  "sub_county_id"?: number;
  "sector_type_id"?: number;
  "sector_category_id"?: number;
  "constituency_id"?: number;
  sector?: Sector;
  report?: Report[];
  county?: County;
  subCounty?: SubCounty;
  sectorType?: SectorType;
  sectorCategory?: SectorCategory;
  constituency?: Constituency;
  services?: ServiceCharterGrouping[];
}

export class Institutions implements InstitutionsInterface {
  "name": string;
  "ownership": string;
  "gender": string;
  "latitude": number;
  "longitude": number;
  "street_address": string;
  "postal_address": string;
  "website": string;
  "service_charter_url": string;
  "contact_name": string;
  "contact_phone": string;
  "contact_email": string;
  "active": boolean;
  "visible": boolean;
  "model": string;
  "property": string;
  "accessType": string;
  "permission": string;
  "principalType": string;
  "principalId": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  "sector_id": number;
  "county_id": number;
  "sub_county_id": number;
  "sector_type_id": number;
  "sector_category_id": number;
  "constituency_id": number;
  sector: Sector;
  report: Report[];
  county: County;
  subCounty: SubCounty;
  sectorType: SectorType;
  sectorCategory: SectorCategory;
  constituency: Constituency;
  services: ServiceCharterGrouping[];
  constructor(data?: InstitutionsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Institutions`.
   */
  public static getModelName() {
    return "Institutions";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Institutions for dynamic purposes.
  **/
  public static factory(data: InstitutionsInterface): Institutions{
    return new Institutions(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Institutions',
      plural: 'Institutions',
      path: 'Institutions',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "ownership": {
          name: 'ownership',
          type: 'string'
        },
        "gender": {
          name: 'gender',
          type: 'string'
        },
        "latitude": {
          name: 'latitude',
          type: 'number'
        },
        "longitude": {
          name: 'longitude',
          type: 'number'
        },
        "street_address": {
          name: 'street_address',
          type: 'string'
        },
        "postal_address": {
          name: 'postal_address',
          type: 'string'
        },
        "website": {
          name: 'website',
          type: 'string'
        },
        "service_charter_url": {
          name: 'service_charter_url',
          type: 'string'
        },
        "contact_name": {
          name: 'contact_name',
          type: 'string'
        },
        "contact_phone": {
          name: 'contact_phone',
          type: 'string'
        },
        "contact_email": {
          name: 'contact_email',
          type: 'string'
        },
        "active": {
          name: 'active',
          type: 'boolean',
          default: true
        },
        "visible": {
          name: 'visible',
          type: 'boolean',
          default: true
        },
        "model": {
          name: 'model',
          type: 'string'
        },
        "property": {
          name: 'property',
          type: 'string'
        },
        "accessType": {
          name: 'accessType',
          type: 'string'
        },
        "permission": {
          name: 'permission',
          type: 'string'
        },
        "principalType": {
          name: 'principalType',
          type: 'string'
        },
        "principalId": {
          name: 'principalId',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
        "sector_id": {
          name: 'sector_id',
          type: 'number'
        },
        "county_id": {
          name: 'county_id',
          type: 'number'
        },
        "sub_county_id": {
          name: 'sub_county_id',
          type: 'number'
        },
        "sector_type_id": {
          name: 'sector_type_id',
          type: 'number'
        },
        "sector_category_id": {
          name: 'sector_category_id',
          type: 'number'
        },
        "constituency_id": {
          name: 'constituency_id',
          type: 'number'
        },
      },
      relations: {
        sector: {
          name: 'sector',
          type: 'Sector',
          model: 'Sector'
        },
        report: {
          name: 'report',
          type: 'Report[]',
          model: 'Report'
        },
        county: {
          name: 'county',
          type: 'County',
          model: 'County'
        },
        subCounty: {
          name: 'subCounty',
          type: 'SubCounty',
          model: 'SubCounty'
        },
        sectorType: {
          name: 'sectorType',
          type: 'SectorType',
          model: 'SectorType'
        },
        sectorCategory: {
          name: 'sectorCategory',
          type: 'SectorCategory',
          model: 'SectorCategory'
        },
        constituency: {
          name: 'constituency',
          type: 'Constituency',
          model: 'Constituency'
        },
        services: {
          name: 'services',
          type: 'ServiceCharterGrouping[]',
          model: 'ServiceCharterGrouping'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/Institutions.ts